import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux'
import FeedbackNote from './FeedbackNote';
import Alert from '../Alert';
import {ajaxCreateNote, setFeedbackAlert} from '../redux/FeedbackRedux';


class NoteSection extends React.Component {
    constructor(props) {
        super(props);
        const id = this.props.feedback_id;
        this.state = {note_text: "", initial_feedback: id, note_user: "", cleared: false, is_open: false};
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
    }

    handleChange(event) {
        this.setState({
            note_text: event.target.value,
        });

        if (this.state.cleared !== false) {
            this.setState({
                cleared: false,
            });
        }
    }

    handleOpenChange(event) {
        event.preventDefault();

        this.setState(
            prevState => ({ is_open: !prevState.is_open }),
            () => {
                const input = document.getElementById('noteInput');
                if (input) {
                    input.focus();
                }
            }
        );
    }

    handleUserChange(event) {
        this.setState({
            note_user: event.target.value
        });
    }

    handleTextClick(event) {
        if (event.target.value === "") {
            this.setState(
                {value: ''}
            );
        }
    }

    handleClick(event) {
        if (this.state.note_text !== "") {
            if (this.props.current_user) {
                this.props.dispatch(ajaxCreateNote(this.state.note_text, this.props.user_id, this.props.feedback.feedback_id, null, this.props.state));
            } else {
                if (this.state.note_text != "" && this.state.note_user != "") {
                    this.props.dispatch(ajaxCreateNote(this.state.note_text, null, this.props.feedback.feedback_id, this.state.note_user, this.props.state));
                } else {
                    var alert = {
                        alert: {
                            alert_class: "danger",
                            alert_message: __('Please Make Sure Both Fields Are Filled Out!'),
                            alert: true,
                            alert_location: "notes"
                        }
                    };
                    this.props.dispatch(setFeedbackAlert(alert));
                }
            }
            this.setState({
                note_text: "",
                note_user: "",
            });
        }
    }

    componentDidUpdate() {
        if (this.state.initial_feedback != this.props.feedback_id && this.state.cleared == false) {
            this.setState({
                note_text: "",
                note_user: "",
                initial_feedback: this.props.feedback_id,
                cleared: true,
            });
        }
    }

    render() {
        return (
            <div className="card-body note-section">
                <Alert alert={this.props.alert} location={'notes'}/>
                <div className={'d-flex align-items-center mb-2'}>
                    <h4 id="notes" className={'mr-2'} data-toggle="tooltip" data-title={ __('Notes that are added to this specific Feedback')}>{__('Internal Notes')}</h4>
                    <span>({__('not seen by Feedbacker')})</span>
                    <div className="ml-2">
                        {!this.state.is_open &&
                            <span className="btn btn-sm btn-primary toggle-notes ml-3 d-inline-block" onClick={this.handleOpenChange.bind(this)}>
                                <i className="fas fa-plus"></i>
                            </span>
                        }
                        {this.state.is_open &&
                            <span className="btn btn-sm btn-primary btn-primary-alt toggle-notes ml-3 d-inline-block" onClick={this.handleOpenChange.bind(this)}>
                                <i className="fas fa-times"></i>
                            </span>
                        }
                    </div>
                </div>
                {this.props?.feedback &&
                    <div className="row detail-list mt-4">
                        {this.props.feedback.notes.map((value, index) => {
                            let classes = "";
                            if (index + 1 === this.props.feedback.notes.length) {
                                classes = "last";
                            };
                            return <FeedbackNote key={index} classes={classes} note={value} id={value.notes_id}/>
                        })}

                        {this.state.is_open &&
                            <div className="col-md-12 mt-0 note-input">
                                <div className="input-group feedback-form-control mb-0 border d-none d-sm-flex">
                                    <div className="input-group-prepend prepend-textarea">
                                        <span className="input-group-text"><i className="fas fa-clipboard"></i></span>
                                    </div>
                                    <textarea id="noteInput" className="form-control pl-0 placeholder-up"
                                              value={this.state.note_text} onClick={this.handleTextClick.bind(this)}
                                              onChange={this.handleChange.bind(this)} placeholder={__('Add a Note...')}
                                              aria-label="Add a Note..."/>
                                    <div className="input-group-append">
                                    </div>
                                </div>
                                {!this.props.current_user &&
                                    <div className="input-group feedback-form-control mt-2 border d-none d-sm-flex">
                                        <div className="input-group-prepend pr-0 mr-0">
                                            <span className="input-group-text"><i className="fas fa-user-edit"></i></span>
                                        </div>
                                        <input type="text" className="form-control pl-0 user_name"
                                               value={this.state.note_user} onChange={this.handleUserChange.bind(this)}
                                               placeholder={__('Your Full Name...')} name="userinfo"/>
                                        <div className="input-group-append">
                                        </div>
                                    </div>
                                }
                                <div className="row d-none d-sm-flex">
                                    <div className="col-sm-12 text-right mt-2">
                                        <button className="btn btn-sm btn-primary ml-auto"
                                                onClick={this.handleClick.bind(this)} type="button"><i
                                            className="fas fa-download mr-1"></i> {__('Save')}</button>
                                    </div>
                                </div>

                                <div className="input-group feedback-form-control mb-0 border d-flex d-sm-none">
                                    <div className="input-group-prepend prepend-textarea">
                                        <span className="input-group-text"><i className="fas fa-clipboard"></i></span>
                                    </div>
                                    <textarea id="noteInput" className="form-control pl-0 placeholder-up"
                                              value={this.state.note_text} onClick={this.handleTextClick.bind(this)}
                                              onChange={this.handleChange.bind(this)} placeholder={__('Add a Note...')}
                                              aria-label="Add a Note..." />
                                    <div className="input-group-append">
                                    </div>
                                </div>
                                {!this.props.current_user &&
                                    <div className="input-group feedback-form-control mt-2 border d-sm-none d-flex">
                                        <div className="input-group-prepend pr-0 mr-0">
                                            <span className="input-group-text"><i className="fas fa-user-edit"></i></span>
                                        </div>
                                        <input type="text" className="form-control pl-0 user_name"
                                               value={this.state.note_user} onChange={this.handleUserChange.bind(this)}
                                               placeholder={__('Your Full Name...')} name="userinfo"/>
                                        <div className="input-group-append">
                                        </div>
                                    </div>
                                }
                                <button className="btn btn-sm btn-primary mt-1 ml-auto d-block d-sm-none btn-save"
                                        onClick={this.handleClick.bind(this)} type="button"><i
                                    className="fas fa-download mr-1"></i> {__('Save')}</button>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {alert: state.alert.alert, feedback_id: state.selected_feedback, current_user: state.current_user, state}
}

export default connect(mapStateToProps)(NoteSection)
